import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock, LogOut, Receipt } from "lucide-react";
import { useAuth } from "../lib/auth";
import { fmtShortDate } from "../lib/format";

function RequestStatus({ a }) {
  if (a.unpaid)
    return <p className="lk-status" data-testid="lock-status">Ubetalt faktura – forfald {fmtShortDate(a.oldest_due)}. Betalingen registreres manuelt, så der kan gå lidt tid.</p>;
  if (a.pending)
    return <p className="lk-status" data-testid="lock-status">Fakturaen er på vej – I får den på mail snarest.</p>;
  if (a.kind === "cancelled")
    return <p className="lk-status" data-testid="lock-status">Abonnementet er stoppet.</p>;
  return <p className="lk-status muted" data-testid="lock-status">I har endnu ikke startet et abonnement.</p>;
}

export default function LockOverlay() {
  const { store, refresh, logout } = useAuth();
  const nav = useNavigate();
  const a = store.access;
  const pastDue = a.kind === "past_due";

  useEffect(() => {
    const t = setInterval(refresh, 30000);
    const onVis = () => document.visibilityState === "visible" && refresh();
    document.addEventListener("visibilitychange", onVis);
    return () => {
      clearInterval(t);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [refresh]);

  return (
    <div className="ck-overlay lk-overlay" role="alertdialog" aria-modal="true" aria-labelledby="lk-title" data-testid="lock-overlay">
      <div className="ck-modal lk-modal">
        <div className="lk-body">
          <span className="lk-ico" aria-hidden="true"><Lock size={24} /></span>
          <h2 id="lk-title" data-testid="lock-title">{pastDue ? "Manglende betaling" : a.kind === "cancelled" ? "Abonnementet er stoppet" : "Prøveperioden er udløbet"}</h2>
          <p>Betal fakturaen for at få adgang til JaTak Pro igen.</p>
          <p className="muted lk-small">Jeres kunder kan stadig se deres ordrer, og igangværende tilbud bliver ved med at køre.</p>
          <RequestStatus a={a} />
          <div className="lk-actions">
            <Link className="btn primary big" to="/billing" data-testid="lock-billing-btn">
              <Receipt size={18} /> {a.started || pastDue ? "Se fakturaer" : "Start abonnement"}
            </Link>
            <button className="btn big" onClick={() => { logout(); nav("/"); }} data-testid="lock-logout-btn">
              <LogOut size={18} /> Log ud
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
